import RevenueBreakdownModule from "./revenueBreakdownModule";
import RevenueBreakdownSagas from "./redux/revenueBreakdownSagas";
import RevenueBreakdownReducer from "./redux/revenueBreakdownReducer";

export default {
  Component: RevenueBreakdownModule,
  moduleName: "revenueBreakdown",
  saga: RevenueBreakdownSagas(),
  reducer: RevenueBreakdownReducer
};
